/* import __COLOCATED_TEMPLATE__ from './header.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';

import type { ComponentLike, ContentValue } from '@glint/template';
import type { Dropdown } from 'ember-basic-dropdown/components/basic-dropdown';

export interface BvPopoverHeaderSignature {
  Args: {
    popover?: Dropdown;
    showCloseButton?: boolean;
    title?: ContentValue | ComponentLike;
  };
  Blocks: {
    default: [popover?: Dropdown];
  };
  Element: HTMLElement;
}

const BvPopoverHeaderComponent = templateOnlyComponent<BvPopoverHeaderSignature>();

export default BvPopoverHeaderComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'BvPopover::Header': typeof BvPopoverHeaderComponent;
    'bv-popover/header': typeof BvPopoverHeaderComponent;
  }
}
